import { render, staticRenderFns } from "./wasteType-edit.vue?vue&type=template&id=b5d47fde&scoped=true&"
import script from "./wasteType-edit.vue?vue&type=script&lang=js&"
export * from "./wasteType-edit.vue?vue&type=script&lang=js&"
import style0 from "./wasteType-edit.vue?vue&type=style&index=0&id=b5d47fde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d47fde",
  null
  
)

export default component.exports